import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, getURLSegment, toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import Session from './Session';
import SessionPlayer from './SessionPlayer';
import AddToCalendar from '../Calendar/AddToCalendar';

const SessionDetail = observer(class SessionDetail extends React.Component {
  constructor() {
    super();
    this.closeSession = this.closeSession.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    const { ScheduleStore } = this.props.store;
    let sessionSid = getURLSegment(this, 2);

    if(this.props.sessionSid) {
      sessionSid = this.props.sessionSid;
    }

    if(ScheduleStore.events.length > 0 && !this.props.timeline) {
      ScheduleStore.getSingleSession(sessionSid);
    } else {
      const callback = () => {
        ScheduleStore.getSingleSession(sessionSid);
      };

      ScheduleStore.getSessions(null, null, callback, sessionSid);
    }

    this.state = {
      slideoutHidden: true,
      hideForm: true
    }
  }

  componentWillUnmount() {
    if(!this.props.timeline){
      this.props.store.ScheduleStore.getSessions(100, 'Scheduled');
    }
  }

  closeSession() {
    const { session } = this.props.store.ScheduleStore;
    const { examSid, installSid, sid } = session;

    const callback = () => this.complete('closed');

    this.props.store.ScheduleStore.closeSession(installSid, examSid, sid, callback);
  }

  complete(action) {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;

    if(action === 'closed') {
      closeDrawer(null, this.props.parent, getURLSegment(this, 1));
      SessionStore.showToaster(translation.closed_message, 'success');
    }
  }

  render() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    let {session} = this.props.store.ScheduleStore;

    const { location } = session;
    let address = location ? `${location.address1 || ''} ${location.address2 || ''}` : '';

    let embed = false;

    if(SessionStore.userData.skin && SessionStore.userData.skin === 'embed') {
      embed = true;
    }
    
    if ((!SessionStore.loading || (SessionStore.loadingCalls.indexOf('getExamFile') > -1)) && session.sid) {
      return (
        <div className="drawer__content">
          

          {session.platformVersion === "3" && session.workflowModule === 'hybrid-scheduling' && ['closed', 'cancelled'].includes(session.status.toLowerCase()) ?
            (
              <SessionPlayer
                session={session}
                parent={this}
                installSid={session.installSid}
                courseSid={session.course.sid}
                examSid={session.examSid}
                {...this.props}
              />
            ) : (
              <React.Fragment>
                {!embed &&
                  <header className="drawer__header">
                    <div className="wrap">
                      <div>
                        <h1 className="drawer__title">
                          {session.enrollment.firstName} {session.enrollment.lastName}
                        </h1>

                        <p className="drawer__note">
                          <span>
                            {moment.utc(session.appointmentDate)
                                    .local()
                                    .tz(moment.tz.guess())
                                    .format('M/D/YYYY [at] h:mma z')}
                          </span>

                          {session.examConfiguration.duration >= 60 &&
                            <span>
                              {toHours(session.examConfiguration.duration, false, false, true)}
                            </span>
                          }

                          {session.examConfiguration.duration < 60 &&
                            <span>
                              {session.examConfiguration.duration} {translation.exam_details.minutes}
                            </span>
                          }
                        </p>
                      </div>

                      <AddToCalendar
                        title={`${session.enrollment.firstName} ${session.enrollment.lastName} – ${session.exam ? session.exam.title : ''}`}
                        start={new Date(session.appointmentDate)}
                        duration={session.examConfiguration.duration}
                        location={`${address} ${location.place}, ${location.region}, ${location.postalCode} ${location.country}`}
                        lat={location.latitude}
                        lon={location.longitude}
                        {...this.props}
                      />
                    </div>
                  </header>
                }
                <ul className="block-list session-list">
                  <Session
                      session={session}
                      parent={this}
                      installSid={session.installSid}
                      courseSid={session.course.sid}
                      examSid={session.examSid}
                      location={location}
                      address={address}
                      {...this.props}
                  />
                  </ul>
                </React.Fragment>
            ) 
          }          
        </div>
      )
    }

    return null;
  }
})

export default translate('SessionDetail')(SessionDetail);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/SessionDetail.js